import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c1cd026")

_pushScopeId("data-v-4c1cd026")
const _hoisted_1 = {
  key: 0,
  class: "hq-banner"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "New Messages From GX", -1)
const _hoisted_3 = {
  key: 1,
  class: "order-banner"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_action_button = _resolveComponent("action-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.hasHqMessages)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_action_button, {
            text: "View All",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.store.toggleShowHqModal($event)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.unreadShopMessages.length)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("span", null, _toDisplayString(_ctx.unreadShopMessages.length) + " " + _toDisplayString(_ctx.orderLabel) + " New Messages", 1),
          _createVNode(_component_action_button, {
            text: "View Message",
            onClick: _ctx.viewOldest
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
})